import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Truck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

const formatErr = (detail) => {
  if (!detail) return "Er ging iets mis. Probeer opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welkom terug!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="rounded-2xl bg-slate-900/60 border border-slate-700/60 p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-sky-500 flex items-center justify-center glow-blue">
              <Truck className="w-6 h-6 text-slate-950" />
            </div>
            <div>
              <h1 className="font-heading text-xl font-bold text-white">Team login</h1>
              <p className="text-sm text-slate-400">Toegang tot het dashboard</p>
            </div>
          </div>
          <form onSubmit={submit} data-testid="login-form" className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-slate-300">E-mailadres</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="team@takeldienst.be" className="bg-slate-950/50 border-slate-700 text-white" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-slate-300">Wachtwoord</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" className="bg-slate-950/50 border-slate-700 text-white" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full h-11 rounded-full bg-sky-500 hover:bg-sky-400 text-slate-950 font-bold gap-2 glow-blue">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-4 h-4" />}
              Inloggen
            </Button>
          </form>
        </div>
        <p className="text-center text-xs text-slate-600 mt-4">Alleen voor teamleden van Takeldienst 24/7</p>
      </div>
    </div>
  );
};

export default Login;
